import React from 'react';
import { Trash2 } from 'lucide-react';

export interface DeleteConfirmState {
  message: string;
  onConfirm: () => void;
}

interface ConfirmDeleteDialogProps {
  state: DeleteConfirmState | null;
  onClose: () => void;
}

export const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({ state, onClose }) => {
  if (!state) return null;
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/40 backdrop-blur-sm">
      <div className="bg-white rounded-2xl shadow-xl p-6 max-w-sm w-full space-y-4 mx-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center shrink-0">
            <Trash2 size={20} className="text-red-600" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-slate-900">Confirm Delete</h3>
            <p className="text-sm text-slate-500">{state.message}</p>
          </div>
        </div>
        <div className="flex gap-2">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 bg-slate-100 text-slate-700 rounded-xl text-sm font-bold hover:bg-slate-200 transition-colors"
          >Cancel</button>
          <button
            onClick={() => { state.onConfirm(); onClose(); }}
            className="flex-1 px-4 py-2.5 bg-red-600 text-white rounded-xl text-sm font-bold hover:bg-red-700 transition-colors"
          >Delete</button>
        </div>
      </div>
    </div>
  );
};
